import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src/types/types'

export const HOTEL_DESCRIPTION_CONTENT_LENGTH = 240

/**
 * `preferHeadline` is for the SEO descriptions, whose headline is written as
 * the intro. SAPI headlines are weaker, so amenities lead there.
 */
export const generateHotelDescription = (
  descriptions: ContentHotel['descriptions'] = {},
  {preferHeadline = false} = {}
) => {
  const {
    amenities = '',
    headline = '',
    overall = '',
    business_amenities = '',
    dining = '',
    location = '',
    rooms = ''
  } = descriptions

  const description = preferHeadline
    ? headline || amenities || overall
    : amenities || headline || overall

  const shouldLimitDescription =
    Boolean(description) &&
    Boolean(location || dining || rooms || business_amenities)

  const descriptionDisplayed =
    shouldLimitDescription &&
    description.length > HOTEL_DESCRIPTION_CONTENT_LENGTH
      ? `${description.slice(0, HOTEL_DESCRIPTION_CONTENT_LENGTH)}...`
      : description

  return {
    descriptionDisplayed,
    shouldLimitDescription
  }
}
